import React from 'react'
import { Container, Col, Row } from 'reactstrap'
import { withGridContext } from '../providers'
import FilterResolver from './field-resolver'
import { ContextType } from '../types/advanced-grid.types'
import Typography from '../../typography'
import Icon from '../../misc/icon'

interface Props {}

/**
 * Renders the table filters and control for the advance search (if enabled)
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const TableFilters: React.FC<Props & ContextType> = ({
    columns,
    events,
    filters,
    filterOptions,
    gridId,
    filterConfig,
    filterValues
}) => {
    const { colSize = {}, fluid } = filterConfig || {}
    const { handleChangeFilter } = events || {}

    const getColumnConfig = (key: string) =>
        (columns || []).find((item) => {
            if (typeof item === 'string') {
                return key === item
            } else {
                return item.key === key
            }
        })

    return (
        <div>
            <Typography className="pl-1 text-sm font-semibold ">
                <Icon type="filter" className="mr-2" size="sm" /> Filters
            </Typography>
            <div className="flex justify-start items-center relative">
                <Container fluid={fluid}>
                    <Row>
                        {filters &&
                            filters.map((filterName, key) => (
                                <Col
                                    className="pl-0 z-50"
                                    key={`filter-${gridId}-${key}`}
                                    {...colSize}
                                >
                                    <FilterResolver
                                        fieldName={filterName as string}
                                        columnConfig={getColumnConfig(filterName)}
                                        filterOptions={
                                            filterOptions ? filterOptions[filterName] : undefined
                                        }
                                        id={`filter-${gridId}-${key}`}
                                        onChange={handleChangeFilter}
                                        value={filterValues ? filterValues[filterName] : ''}
                                    />
                                </Col>
                            ))}
                    </Row>
                </Container>
            </div>
        </div>
    )
}

TableFilters.defaultProps = {
    filterConfig: {
        colSize: {
            sm: '3',
            xs: '3',
            md: '3',
            lg: '3'
        },
        fluid: true
    }
}

export default withGridContext(TableFilters)
